export default "__VITE_ASSET__C8cyF$jB__"